type ShareSeriesProps = {
  standard: string;
};
export function ShareSeries({ standard }: ShareSeriesProps) {
  return (
    <euroland-tool data-tool-name="ShareSeries" data-tool-language={standard} />
  );
}
